import React, { FC } from 'react';
import styles from './feature-title.module.css';

const FeatureTitle: FC<{ title: string }> = ({ title }) => {
  return <h1 className={styles.title}>{title}</h1>;
};

export default FeatureTitle;
